import React from 'react';

import useStackedAreaData from './useStackedAreaData';
import StackedAreaView from './StackedAreaView';

const StackedAreaContent = ({
  chartDefinition,
  chartRef,
}: {
  chartDefinition: V5ChartDefinition;
  chartRef: React.MutableRefObject<any>;
}) => {
  const { options } = useStackedAreaData({ chartDefinition, chartRef });

  return (
    <StackedAreaView
      chartRef={chartRef}
      options={options}
      chartDefinitionId={chartDefinition.id}
    />
  );
};

export default StackedAreaContent;
